module.exports = __webpack_public_path__ + "static/media/emailLogo.e3207688.svg";